import React from "react";
import AppRoutes from "./AppRoutes";

export default function App() {
  return (
    <div className="bg-gray-50 min-h-screen font-serif">
      <AppRoutes />
    </div>
  );
}
